import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div style={{ position: "fixed", bottom: 0 }}>
                <footer className='footer'><span>All Rights 2023 @DevChakra</span></footer>
            </div>
        );
    }
}

export default Footer;